// extracted by mini-css-extract-plugin
export default {"styles":"styles___Bfbdb","title":"title___fSGs9","prefix":"prefix___I4ecS","dot":"dot___wFVTX","dotHidden":"dotHidden___lwoH6"};